import React from "react";
import moment from "moment"
import { Modal, Button, Container } from 'react-bootstrap';
import {
    SCHEDULING_IMPACT_MITIGATION_PLAN_MODAL_TITLE,
    OPERATION_IMPACT_MITIGATION_PLAN_MODAL_TITLE
} from '../constants/outage-schedule-report'

const isSchedulingOrOps = showSchedulingModal => showSchedulingModal ?
    'Scheduling' : 'Operations'

const getColumnTitles = (showSchedulingModal) => {
    const schedulingOrOperation = isSchedulingOrOps(showSchedulingModal)
    const impact = `${schedulingOrOperation} Impact`
    const plan = `${schedulingOrOperation}  Impact & Mitigation Plan`
    
    return (
        <div className="row otgmodel-row" key="prev-cmt-modal-cols-title">
            <div className="col-md-2 otgmodel-dtlbl">Date</div>
            <div className="col-md-2 otgmodel-dtlbl">{impact}</div>
            <div className="col-md-8 otgmodel-dtlbl">{plan}</div>
        </div>
    )
}

const getModalContent = (commentData, showSchedulingModal, showOperationsModal) => {
    const columnTitles = getColumnTitles(showSchedulingModal)
    const content = commentData.map((comment, index) => {
        let impact = null
        let mitigationPlan = null
        const utcTime = new Date(comment.dateTime.toString())
        const localTime = moment(utcTime).format('MM/DD/YYYY h:mm a')
        if (showSchedulingModal) {
            impact = comment?.schedulingImpact
            mitigationPlan = comment?.schedulingImpactAndMitigationPlan
        }
        if (showOperationsModal) {
            if (comment?.operationsImpact === true) {
                impact = 'Yes'
            }
            if (comment?.operationsImpact === false) {
                impact = 'No'
            }
            mitigationPlan = comment?.operationsImpactAndMitigationPlan
        }

        return (
            <div className="row otgmodel-row" key={index}>
                <div className="col-md-2">
                    <label>{localTime}</label>
                </div>
                <div className="col-md-2">
                    <label>{impact}</label>
                </div>
                <div className="col-md-8">
                    <label>{mitigationPlan}</label>
                </div>
            </div>
        )
    })
    content.unshift(columnTitles)
    return content
}

const getModalTitle = (showSchedulingModal, showOperationsModal) => {
    if (showSchedulingModal)
        return SCHEDULING_IMPACT_MITIGATION_PLAN_MODAL_TITLE
    if (showOperationsModal)
        return OPERATION_IMPACT_MITIGATION_PLAN_MODAL_TITLE
    return null
}

export const PrevCommentsModal = (props) => {
    const { showSchedulingModal, showOperationsModal, commentData, closeModal } = props
    const content = commentData?.length ?
        getModalContent(commentData, showSchedulingModal, showOperationsModal) : null

    return content ? (
        <Modal
            show={showSchedulingModal || showOperationsModal}
            dialogClassName="otgmodal-80w"
        >
            <Modal.Header className="otgmodel-header">
                <Modal.Title>{getModalTitle(showSchedulingModal, showOperationsModal)}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="otgmodel-body">
                <Container>{content}</Container>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={closeModal}
                    className="otgmodel-header"
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    ) : null
}